import React from 'react'
import Popup from '../components/Popup'
import { Box, Typography } from '@mui/material'
import question from "../../../../Assets/img/Login/question.png"
import ButtonComp from '../../../ButtonComp/ButtonComp'
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';

const NeedHelp = ({isOpen, onClose}) => {
  return (
    <>
      <Popup
        isOpen={isOpen}
        onClose={onClose}
        image={question}
        text="Need Help ?"
      >
        <Typography variant="subtitle1" sx={{ textAlign: "center", maxWidth: "420px" }}>
          If you don’t have access to the registered email, reach out to us for support.
        </Typography>
        <Typography variant='h6' sx={{fontWeight:600}}>Contact Details: </Typography>

        <Box sx={{display:'flex' , flexDirection:'column' , gap:'10px'}}>
          <a href="mailto:support@yourorganization.com" style={{ textDecoration: 'none'}}>
            <Typography variant="subtitle1" sx={{ textAlign: "center", maxWidth: "420px", fontWeight:600 ,'&:hover':{textDecoration:'underline'}}}>
              <EmailIcon sx={{color:'black'}}/> &nbsp;
              support@yourorganization.com
            </Typography>
          </a>
          <a href="tel:1234567890" style={{ textDecoration: 'none' }}>
            <Typography variant="subtitle1" sx={{ textAlign: "center", maxWidth: "420px", fontWeight:600 }}>
              <CallIcon sx={{color:'black'}}/> &nbsp;
                +1-234-567-890
            </Typography>
          </a>
        </Box>

        <ButtonComp
          text={"Close"} onClick={onClose}
          className="px-[40px] rounded-full bg-[#ED1C24] text-[white] py-[10px] leading-5"
        />
      </Popup>
    </>
  )
}

export default NeedHelp